import { z } from "zod";

export enum Step {
    Initial = 0,
    Verification = 1,
    PasswordReset = 2,
}

export const resetPasswordSchema = z
    .object({
        password: z.string().min(1, "Password is required"),
        passwordScore: z.number().optional(),
        verificationCode: z.string(),
        clientPublicId: z.string(),
        step: z.nativeEnum(Step),
    })
    .superRefine((values, ctx) => {
        if (values.passwordScore < 2) {
            // to highlight with error color the password field
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                path: ["password"],
                message: "",
            });
        }

        if (values.step === Step.Verification) {
            if (!values.verificationCode) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    path: ["verificationCode"],
                    message: "Verification code is required",
                });
            } else if (values.verificationCode.length !== 6) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    path: ["verificationCode"],
                    message: "Verification code must be 6 characters long",
                });
            }
        }
    });

export type ResetPasswordType = z.infer<typeof resetPasswordSchema>;

export const generateDefaultValues = (clientPublicId: string) =>
    ({
        password: "",
        verificationCode: "",
        clientPublicId: clientPublicId,
        step: Step.Initial,
    }) as ResetPasswordType;
